import moment from "moment";

const ID_TOKEN_KEY = "token_telainicial_spirit";

export const getToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
};

const SISTEMA = "sistema_telainicial_spirit";

export const getSistema = () => {
    return window.localStorage.getItem(SISTEMA);
};

export const saveSistema = sistema => {
    window.localStorage.setItem(SISTEMA, sistema);
};

export const destroySistema = () => {
    window.localStorage.removeItem(SISTEMA);
};

export const criarObterGenerico = (configuracao, valor) => {
    let valorSalvo = window.localStorage.getItem(configuracao);

    if (valorSalvo) {
        return valorSalvo;
    } else {
        window.localStorage.setItem(configuracao, valor);
        return valor;
    }
};

export const salvarGenerico = (configuracao, valor) => {
    window.localStorage.setItem(configuracao, valor);
};

export const removerGenerico = (configuracao) => {
    window.localStorage.removeItem(configuracao);
};

export const criarObterGenericoComValidade = (configuracao, valor) => {
    let valorSalvo = window.localStorage.getItem(configuracao);

    if (valorSalvo) {
        valorSalvo = JSON.parse(valorSalvo);

        if ((valorSalvo) && (valorSalvo.validade == moment().format("YYYY-MM-DD"))) {
            return valorSalvo.valor;
        } else {
            window.localStorage.setItem(configuracao, JSON.stringify({
                valor, 
                validade: moment().format("YYYY-MM-DD")
            }));
            return valor;
        }
    } else {
        window.localStorage.setItem(configuracao, JSON.stringify({
            valor, 
            validade: moment().format("YYYY-MM-DD")
        }));
        return valor;
    }
};

export const salvarGenericoComValidade = (configuracao, valor) => {
    window.localStorage.setItem(configuracao, JSON.stringify({
        valor,
        validade: moment().format("YYYY-MM-DD")
    }));
};

export default {
    getToken, 
    saveToken, 
    destroyToken, 
    getSistema, 
    saveSistema, 
    destroySistema, 
    criarObterGenerico, 
    salvarGenerico, 
    removerGenerico,
    criarObterGenericoComValidade, 
    salvarGenericoComValidade
};
